import { AxiosError } from 'axios'

export const isNotFoundError = (error: AxiosError) =>
	error.response?.status === 404

export const isInternalServerError = (error: AxiosError) =>
	error.response?.status === 500
